module.exports = __webpack_public_path__ + "static/media/covi_too_enh_cle.6d07135f.png";